import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
// import Statistis from "./Statistics";
// import { ReactComponent as SmallDhiramIcon } from "../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { ReactComponent as MwebDhiramIcon } from "../../../../assets/svg/MwebDhiramIcon.svg";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { CHANGE_REQUEST_STATUS } from "../../../../config/constants";
import { toast } from "react-toastify";
import { useState } from "react";
import Permission from "../../../../components/Permission";
import { Setting } from "../../../../utils/Setting";
import { getApiData } from "../../../../utils/APIHelper";
import { statusStyleArray } from "../config";
import { useTheme } from "@emotion/react";
import { getTypeStyle } from "./changeRequestTypeStyles";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

const User = ({ user }) => {
  if (!user) return null;
  const getUserInitials = (name) => {
    if (!name) return "";
    const nameParts = name.trim().split(" ");
    if (nameParts.length === 1) return nameParts[0].charAt(0).toUpperCase();
    return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {user.profile ? (
        <img
          src={user.profile}
          alt={user.username}
          style={{ width: "32px", height: "32px", borderRadius: "50%", objectFit: "cover" }}
        />
      ) : (
        <Box
          sx={{
            width: "34px",
            height: "34px",
            borderRadius: "50%",
            backgroundColor: "#e6f0ff",
            color: "#1a73e8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            fontWeight: "600",
            flexShrink: 0
          }}
        >
          {getUserInitials(user.username)}
        </Box>
      )}
      <p style={{ color: "#000", fontWeight: "500", fontSize: "14px", margin: 0 }}>
        {user.username}
      </p>
    </Box>
  );
};

const MobileView = ({
  list,
  handleChange,
  handleApproveClick,
  loadingItems,
}) => {
  return (
    <div style={mobileStyles.container}>
      <div style={mobileStyles.changelogContainer}>
        {list?.map((item, index) => (
          <div key={item.id} style={mobileStyles.changelogCard}>
            {/* Row 1: Type (Pill) */}
            <div style={mobileStyles.row}>
              <Typography
                onClick={() => handleChange(item)}
                style={{
                  ...mobileStyles.nameValue,
                  borderRadius: "34px",
                  padding: "4px 8px",
                  fontSize: "14px",
                  minWidth: "7ch",
                  width: "fit-content",
                  backgroundColor: getTypeStyle(item?.type).backgroundColor,
                  color: getTypeStyle(item?.type).color,
                  border: "none",
                  cursor: "pointer",
                }}
              >
                {getTypeStyle(item?.type).text}
              </Typography>
            </div>

            {/* Row 2: Status & Created By */}
            <div style={mobileStyles.row}>
              <div style={mobileStyles.dateStatusContainer}>
                <div style={mobileStyles.statusItem}>
                  <Typography style={mobileStyles.statusLabel}>
                    Status
                  </Typography>
                  <div style={mobileStyles.statusContainer}>
                    <Box
                      style={{
                        ...mobileStyles.statusDot,
                        backgroundColor:
                          statusStyleArray.find(
                            (style) => style.status === item?.status
                          )?.backgroundColor || "#FFAD5C",
                      }}
                    />
                    <Typography style={mobileStyles.statusText}>
                      {getStatusDisplayText(item?.status)}
                    </Typography>
                  </div>
                </div>

                <div style={mobileStyles.dateItem}>
                  <Typography style={mobileStyles.dateLabel}>
                    Created By
                  </Typography>
                  <User user={item?.user} />
                </div>
              </div>
            </div>

            {/* Row 3: Cost */}
            <div style={mobileStyles.row}>
              <div style={mobileStyles.priceDateContainer}>
                <div style={mobileStyles.priceItem}>
                  <Typography style={mobileStyles.priceLabel}>Cost</Typography>
                  <Typography style={mobileStyles.priceValue}>
                    <MwebDhiramIcon />
                    &nbsp;
                    {formattedAmountWithoutAed(item?.changeRequestCost) || "-"}
                  </Typography>
                </div>
              </div>
            </div>

            {/* Row 4: Approve Button */}
            {item?.status ===
              CHANGE_REQUEST_STATUS?.AWAITING_CONTRACTOR_CONFIRMATION && (
                <Permission resource="CHANGE_REQUESTS" action="UPDATE">
                  <div style={mobileStyles.buttonContainer}>
                    <Button
                      onClick={() => handleApproveClick(item)}
                      variant="contained"
                      disabled={loadingItems.includes(
                        item?.changeRequestId
                      )}
                      sx={{
                        backgroundColor: "#4D6BF6",
                        borderRadius: "12px",
                        fontSize: "14px",
                        fontWeight: 500,
                        boxShadow: "none",
                        color: "#fff",
                        border: "none",
                        padding: ".7vh 1vw",
                        cursor: "pointer",
                        fontFamily: "Inter Tight",
                        whiteSpace: "nowrap",
                        width: "100% !important",
                        "&:hover": {
                          backgroundColor: "#4D6BF6",
                          border: "none",
                        },
                      }}
                    >
                      Approve
                    </Button>
                  </div>
                </Permission>
              )}
          </div>
        ))}
      </div>
    </div>
  );
};

const mobileStyles = {
  container: {
    padding: "2vh 0",
    backgroundColor: "#fff",
  },
  changelogContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  changelogCard: {
    backgroundColor: "#fff",
    borderRadius: "none",
    padding: "16px 0",
    borderBottom: "1px solid #D7D8D9",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  row: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  nameLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  nameValue: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
    cursor: "pointer",
  },
  dateStatusContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "12px",
  },
  dateItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  dateLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  dateValue: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  statusItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  statusLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  statusDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "3px solid rgb(229, 229, 229)",
  },
  statusText: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
  },
  priceDateContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "12px",
  },
  priceItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  priceLabel: {
    fontSize: "10px",
    color: "#666",
    marginBottom: "2px",
  },
  priceValue: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  buttonContainer: {
    marginTop: "8px",
  },
};

export default function ChangeRequestList({ list, refetch }) {
  const [loadingItems, setLoadingItems] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (item) => {
    navigate(
      `/project/details/${id}/change-request?change=${item?.changeRequestId || item?.changeRequest?.changeRequestId}&type=${item?.type}`
    );
  };

  const handleApproveClick = async (cr) => {
    const cid = cr?.changeRequestId;
    const isTimelineOrDesign =
      cr?.type === "TIMELINE" || cr?.type === "DESIGN";

    setLoadingItems((prev) => [...prev, cid]);

    try {
      if (isTimelineOrDesign) {
        const id = Number(cid);
        await getApiData(
          Setting.endpoints.changeRequest.timelineOrDesignApprove(id),
          "PUT",
          { id, action: "APPROVE" },
          { "Content-Type": "application/json" },
          true
        );
      } else {
        await getApiData(
          Setting.endpoints.changeRequest.approve(cid),
          "PUT",
          {},
          {},
          true
        );
      }
      refetch?.();
      toast.success("Change Request Approved");
    } catch (err) {
      toast.error(err.message || "Something went wrong!");
    } finally {
      setLoadingItems((prev) => [...prev].filter((it) => it !== cid));
    }
  };

  if (isMobile) {
    return (
      <MobileView
        list={list}
        handleChange={handleChange}
        handleApproveClick={handleApproveClick}
        loadingItems={loadingItems}
      />
    );
  }

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "visible",
          boxShadow: "none",
        }}
      >
        <Table
          sx={{
            "& thead": {
              "& th": {
                color: "#949DAA",
                fontWeight: "500",
              },
            },
            "& tbody": {
              "& tr:hover": {
                backgroundColor: "#f7f7f7",
              },
              "& tr": {
                borderBottom: "none",
              },
            },
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Type</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Created By</StyledTableCell>
              <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                <strong
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  Cost ({renderCurrencyIcon('small')})
                </strong>
              </StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list?.map((item, idx) => (
              <TableRow key={item.id}>
                {console.log("cghecc", item)}
                <StyledTableCell style={{ fontWeight: "600 !important" }}>
                  <Typography
                    onClick={() => handleChange(item)}
                    style={{
                      borderRadius: "34px",
                      padding: "4px 8px",
                      fontSize: "14px",
                      minWidth: "7ch",
                      width: "fit-content",
                      backgroundColor: getTypeStyle(item?.type).backgroundColor,
                      color: getTypeStyle(item?.type).color,
                      border: "none",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {getTypeStyle(item?.type).text}
                  </Typography>
                </StyledTableCell>

                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        backgroundColor:
                          statusStyleArray.find(
                            (style) =>
                              style.status === item?.status
                          )?.backgroundColor || "transparent",
                        border: "3px solid #e5e5e5",
                      }}
                    />
                    <Typography
                      style={{
                        fontSize: "14px",
                        marginLeft: "8px",
                        color: "#0D0D0E",
                      }}
                    >
                      {getStatusDisplayText(item?.status)}
                    </Typography>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <User user={item?.user} />
                </StyledTableCell>

                <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                  {`${formattedAmountWithoutAed(
                    item?.changeRequestCost
                  )}`}
                </StyledTableCell>

                <StyledTableCell>
                  {item?.status ===
                    CHANGE_REQUEST_STATUS?.AWAITING_CONTRACTOR_CONFIRMATION && (
                      <Permission resource="CHANGE_REQUESTS" action="UPDATE">
                        <Button
                          onClick={() => handleApproveClick(item)}
                          variant="contained"
                          color="primary"
                          disabled={loadingItems?.includes(item?.changeRequestId)}
                        >
                          Approve
                        </Button>
                      </Permission>
                    )}
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
